import { Component, Input, Output } from "rete";
import Socket from "../sockets";
import { NumberControl, SwitchControl, DropdownControl } from "../controls";
import Node from "./node-components/node";

export class StaCalc extends Component {
  constructor(component) {
    super("STA");
    this.data = {
      render: "vue",
      component: Node,
      props: { type: "calc", comp: component || null }
    };
    this.parentComp = component || null;
  }

  builder(node) {
    const calcInput = new Input("calculation-input", "", Socket["calc"]);
    const matrixInput = new Input(
      "demand-input",
      "Матрица корреспонденций",
      Socket["demand-matrix"]
    );

    const calcOutput = new Output("calculation-output", "", Socket["calc"]);
    const staOutput = new Output("sta-output", "STA", Socket["sta"]);

    matrixInput.addControl(
      new DropdownControl(
        this.editor,
        "demandId",
        "demand",
        true,
        "Choose demand matrix",
        this.parentComp
      )
    );

    if (node.data.switch === undefined) node.data.switch = true;

    return node
      .addInput(calcInput)
      .addInput(matrixInput)
      .addControl(
        new SwitchControl(this.editor, "switch", "switcher", false, node)
      )
      .addControl(
        new DropdownControl(
          this.editor,
          "staId",
          "sta",
          false,
          "Choose sta",
          this.parentComp
        )
      )
      .addControl(
        new NumberControl(this.editor, "start", "number", false, "Время начала")
      )
      .addControl(
        new NumberControl(this.editor, "step", "number", false, "Шаг")
      )
      .addControl(
        new NumberControl(
          this.editor,
          "horizone",
          "number",
          false,
          "Горизонт моделирования",
          true,
          10
        )
      )
      .addOutput(calcOutput)
      .addOutput(staOutput);
  }

  async worker(node) {
    const calcInput = node.inputs["calculation-input"];

    if (calcInput.connections.length) {
      const { nodes } = await this.editor.toJSON();
      const earlyNode = nodes[calcInput.connections[0].node];
      if (!earlyNode.data.switch) node.data.switch = false;
    }
  }
}
